/* eslint-disable no-param-reassign */
import Util from './Util';

export default class CurrentPathUtil {
    static currentPathKey() {
        const urlParam = Util.getURLparameter('path_storage');
        if (urlParam) {
            return urlParam;
        }

        return 'pathStorage';
    }

    static saveCurrentPath(path) {
        Util.setLocalStorage(CurrentPathUtil.currentPathKey(), path);
    }

    static loadCurrentPath() {
        const openPath = Util.getURLparameter('open_path');
        if (openPath) {
            return openPath.split(',');
        }
        return Util.getLocalStorage(CurrentPathUtil.currentPathKey(), true);
    }

    static discloseBreadcrumb(folderData, path) {
        if (folderData.children) {
            for (let i = 0; i < folderData.children.length; i += 1) {
                const child = folderData.children[i];
                if (path.includes(child.path)) {
                    folderData.disclosure = true;
                }
                CurrentPathUtil.discloseBreadcrumb(child, path);
            }
        }
    }
}
